import React from "react";

// Anything stamped on the machine (asset code, fault number, serial, plate, qr_id)
// or anything you add up (dates, amounts, hours, stock). One component, so the
// same number never gets three different treatments across three screens.
// "data" is louder than the sans beside it through weight and full-strength
// colour — that is what keeps the asset code outranking brand/model.
const SIZES = {
  row: "text-data text-foreground",
  body: "text-body font-medium text-foreground",
  plate: "text-display text-white",
  small: "text-data text-muted-foreground",
};

export const Code = ({ children, size = "row", className = "", ...props }) => (
  <span className={`font-mono tabular-nums ${SIZES[size] || SIZES.row} ${className}`} {...props}>
    {children}
  </span>
);
